/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */

import {
  LogLevel,
  Configuration,
  BrowserCacheLocation,
} from '@azure/msal-browser';
import {
  redirectUri,
  postLogoutRedirectUri,
  apiUrl,
  azureAdCLientId,
  aadScopesUserImpersonation,
  logLevel,
  PiiEnabled,
} from 'src/environments/environment';

// const isIE =
//   window.navigator.userAgent.indexOf('MSIE ') > -1 ||
//   window.navigator.userAgent.indexOf('Trident/') > -1;

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: azureAdCLientId,
    authority:
      'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a', // The Azure cloud instance and the app's sign-in audience (tenant ID, common, organizations, or consumers)
    redirectUri: redirectUri, //This is your redirect URI
    postLogoutRedirectUri: postLogoutRedirectUri, // Indicates the page to navigate after logout.
    // Setting this to false is better for hash routing - MSAL will handle redirect properly
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.MemoryStorage, // Use memory storage only - tokens stored in HttpOnly cookies instead
    storeAuthStateInCookie: true, // Store auth state in cookies for XSS protection - enables cookie-based state management
  },
  system: {
    allowNativeBroker: false,
    // Allow redirect promise to be resolved before another interaction
    allowRedirectInIframe: true,
    // Use fragment response mode for hash routing compatibility
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        console.log(message);
      },
      logLevel: logLevel,
      piiLoggingEnabled: PiiEnabled,
    },
  },
};

export const aadScopes = [aadScopesUserImpersonation];

export const protectedResources = {
  apiUsers: {
    endpoint: apiUrl + 'api/Users',
    scopes: {
      all: aadScopes,
    },
  },
  apiProjects: {
    endpoint: apiUrl + 'api/Projects',
    scopes: {
      all: aadScopes,
    },
  },
  apiReaderProjects: {
    endpoint: apiUrl + 'api/v2/Projects',
    scopes: {
      all: aadScopes,
    },
  },
  apiCloudAccounts: {
    endpoint: apiUrl + 'api/CloudAccounts',
    scopes: {
      all: aadScopes,
    },
  },
  apiClusters: {
    endpoint: apiUrl + 'api/Clusters',
    scopes: {
      all: aadScopes,
    },
  },
  apiAskAi: {
    endpoint: apiUrl + 'api/AskAi',
    scopes: {
      all: aadScopes,
    },
  },
};
